<template>
  <!-- 案件詳細 -->
  <div id="CpapRequestDetail">
    <div id="container" v-bind:key="renderKey">
      <div class="labelTitle lable">CPAP 案件詳細</div>
      <!-- QA68_20231228 -->
      <!-- <span v-if="props.row.depositUseFlag" class="depositUse"/> -->
      <table style="width:100px;">
        <tr>
          <td>
            <div v-if="this.targetData.notDirections" style="text-align:center; font-size:20px; background-color: darkorange; border-radius: 8px 8px 8px 8px;"><strong>仮 持 出</strong></div>
            <div v-else-if="kind!='Transfer' && kind!='Cancel' && this.targetData.depositUseFlag" style="text-align:center; font-size:20px; background-color: aquamarine; border-radius: 8px 8px 8px 8px;"><strong>預 託 機</strong></div>
          </td>
        </tr>
      </table>
      <table style="width:1200px;">
        <tr>
          <td>
            <div v-if="(this.targetData.notDirections || this.resume) && (this.targetData.status == 1 || this.targetData.status == 2)" style="text-align:center; font-size:20px; color:red;">仮持出IDを選択してから時間が経過している場合は、再度WEB上の仮持出IDを選択してください。<br>（WEB上の仮持出が使用されているケースがあるため）</div>
            <div v-else-if="this.targetData.depositUseFlag && (this.targetData.status == 1 || this.targetData.status == 2)" style="text-align:center; font-size:20px; color:red;">預託オーダーIDを選択してから時間が経過している場合は、再度WEB上の預託オーダー選択を実施してください。<br>（WEB上の預託機が使用されているケースがあるため）</div>
          </td>
        </tr>
      </table>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
        <b-button class="pdfbutton is-primary" v-if="((targetData.reportFormatType == 1 || targetData.reportFormatType == 2 || targetData.reportFormatType == 3 || targetData.reportFormatType == 4)&&(targetData.kind == 1 || targetData.kind == 2 || targetData.kind == 3 || targetData.kind == 4 || targetData.kind == 5 || targetData.kind == 7) && targetData.status != 15 && !isTransferCancel)" icon-left="printer" v-on:click="downloadInstructionsPDF">署名欄付き指示書PDF</b-button>
      </div>
      <!--処方申込　申込中--><!--仮持出申込　申込中-->
      <cpapRequestDetailEdit v-if="type=='editReq'||type=='editTemp'" ref="detailEdit" :data="targetData" :innerUser="true" :temp="tempFlg" :resume="resume" :comment="false" :circulation="true" :initialUseModule="initialUseModule" :initialUseMoist="initialUseMoist" :isShowProject="true" :compareTarget="compareTarget"/> <!-- QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白-->
      <!--処方申込　登録済み--><!--仮持出申込　登録済み--><!--転院申込-->
      <cpapRequestDetail v-else-if="type=='showReq'||type=='showTemp'||kind=='Transfer'||kind=='Cancel'" ref="detail" :data="targetData" :showRequestInfo="true" :innerUser="true" :kind="targetData.kind" :isEdit="mode=='edit'||targetData.isTransferUndecided" :cancelEdit="mode=='edit'" :deliveryHidden="targetData.depositUseFlag || targetData.notDirections" v-on:back="back" :isResume="resume" :isShowProject="true" :isTransferCancel="isTransferCancel"/>
      <!--置き在庫申込　申込中-->
      <cpapInstrumentRequestDetailEdit v-else-if="type=='editIns'" :data="targetData"/>
      <!--置き在庫申込　登録済み-->
      <cpapInstrumentRequestDetail v-else-if="type=='showIns'" :data="targetData" :showRequestInfo="true"/>

      <div class="button-area">
        <!--確定前の場合-->
        <b-button v-if="mode=='edit' && !isTransferCancel" class="is-primary" @click="cancelReasonInputModalActive=true">キャンセルする</b-button>
        <!--確定前(中止,転院以外)の保存-->
        <b-button v-if="mode=='edit'&&kind!='Transfer'&&kind!='Cancel'" class="is-primary" v-on:click="save">保存する</b-button>
        <!--中止申込みの保存-->
        <b-button v-if="type=='editCancel' && !isTransferCancel" class="is-primary" v-on:click="cancelSave">保存する</b-button>
        <!--転院申込みの保存-->
        <b-button v-if="type=='editTransfer'" class="is-primary" v-on:click="transFerSave">保存する</b-button>
        <!-- 新規処方申込みの確定：患者登録済みかつ、見積もりコード設定済み　預託処方変更で預託オーダーIDが未選択は非活性 返却のみの場合は活性-->
        <b-button v-if="type=='editReq' || type=='editIns'||type=='editTemp'" class="is-primary" v-on:click="confirm" :disabled="!targetData.estimateCode || !targetData.patientCode || (targetData.depositUseFlag && (!targetData.depositUseOrderId && !targetData.depositUseMoistId && !targetData.depositUseModuleId))">確定する</b-button>
        <!-- 中止申込みの確定 -->
        <b-button v-if="type=='editCancel' && !isTransferCancel" class="is-primary" v-on:click="cancelConfirm" :disabled="orderFlg">確定する</b-button>
        <!-- QA418 転院から中止申込みに変更 -->
        <b-button v-if="type=='editCancel' && isTransferCancel" class="is-primary" v-on:click="transferCancel">確定する</b-button>
        <!-- 転院申込みの確定 -->
        <b-button v-if="type=='editTransfer'" class="is-primary" v-on:click="transFerConfirm">確定する</b-button>

        <!--確定済みの差し戻し(機器準備中かつ新規申込、処方変更又は処方再開、川越直送)-->
        <b-button v-if="mode=='show' && targetData.status == cpapRequestStatus.preparingEquipment && (roleId === role.role_admin || roleId === role.role_kawagoe_cpap)　&& (targetData.kind == cpapKindMap.application || targetData.kind == cpapKindMap.applicationChange || targetData.kind == cpapKindMap.applicationResume) && targetData.senderType == cpapSenderMaster[0].code " class="is-primary" @click="sendBackReasonInputModalActive=true">差し戻し</b-button>

        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
        <reasonInputModal v-on:setReason="cancel" v-bind:title="'キャンセル理由入力'"></reasonInputModal>
      </b-modal>
      <b-modal :active.sync="sendBackReasonInputModalActive" has-modal-card>
        <reasonInputModal v-on:setReason="sendBack" v-bind:title="'差し戻し理由入力'"></reasonInputModal>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { cpapRequestStatus,role,cpapKindMap,cpapSenderMaster } from "@/components/mock/base/const.js";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";
import CpapRequestDetailEdit from "@/components/mock/common/CpapRequestDetailEdit";
import CpapInstrumentRequestDetail from "@/components/mock/common/CpapInstrumentRequestDetail";
import CpapInstrumentRequestDetailEdit from "@/components/mock/common/CpapInstrumentRequestDetailEdit";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";

export default {
  name: "CpapRequestDetail",
  methods: {
    back: function() {
      if (!this.isTransferCancel) {
        this.$router.push({
          name: "CpapRequestSearch",
          params: { searchConditions: this.searchParams },
        });
      } else {
        // QA418 患者詳細に戻る
        this.$router.push({
          name:'CpapAgentPatientDetail',
          params:{
            targetId: this.targetId,
            searchConditions: this.searchParams,
            temp: this.tempFlg,
            progress: this.getCpapProgres(this.targetData.status),
            kind: this.targetData.applicationType,
            cancelResume: this.targetData.cancelResume
          }
        });
      }
    },
    save: async function() {
      // 申請保存
      var child = this.$refs.detailEdit;
      var errorMsg = "";
      this.targetData.mode = child.getMode()

      /** 品目情報 */
      var model = this.modelList.find(item => item.reportFormatType == this.targetData.reportFormatType)
      if (this.targetData.estimateDetailCode) {
        let codes = model.itemCodes
        let targets = this.targetData.estimateDetailCode.filter(val => codes.indexOf(val.itemCode) != -1)
        if(targets.length < 1){
          errorMsg = errorMsg + "CPAP機器が選択されていません。\n";
        }
        if(targets.length > 1){
          errorMsg = errorMsg + "CPAP機器が複数選択されています。\n";
        }
      }

      /** 医療機関情報 */
      var hospitalInfo = document.getElementsByClassName("hospitalInfo");
      var hospitalInfoResult = this.selfMadeValidation(hospitalInfo);
      errorMsg = errorMsg + hospitalInfoResult.msg;

      /** 患者情報 */
      var patientInfo = document.getElementsByClassName("patientInfo");
      var patientInfoResult = this.selfMadeValidation(patientInfo);
      errorMsg = errorMsg + patientInfoResult.msg;

      // 電話番号は携帯か自宅のどちらかが必須
      var phoneNumber = document.getElementById("phoneNumber");
      var mobilePhone = document.getElementById("mobilePhone");
      phoneNumber.style["border-color"] = "";
      mobilePhone.style["border-color"] = "";
      if(!this.targetData.patient.phoneNumber && !this.targetData.patient.mobilePhone){
        errorMsg = errorMsg + "「連絡先（携帯電話）」「連絡（自宅・その他）」いずれかは必須項目です。\n"
        phoneNumber.style["border-color"] = "red";
        mobilePhone.style["border-color"] = "red";
      }

      /** 装置情報 */
      var modelInfo = document.getElementsByClassName("modelInfo");
      var modelInfoResult = this.selfMadeValidation(modelInfo);
      errorMsg = errorMsg + modelInfoResult.msg;

      /** 設定情報 相関チェック */
      var correlationList = [];
      if (this.targetData.mode) {
        switch(model.reportFormatType){
          case 1:
            // ドリームステーションAuto
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "1"){
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) {
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else{
              var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
          case 2:
            // ドリームステーションPro
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
              if(Number(lampStart.value) > Number(pressureCpap.value)){
                // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                correlationList.push({
                  displayOrder: lampStart.displayOrder,
                  msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                });
              }
            }
  
            break;
          case 3:
            // ドリームステーションGo
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "1"){
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else{
              var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
          case 4:
            // ドリームステーションBiPAP Auto
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "4"){
              // CPAPモード
              var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.targetData.mode == "8"){
              // Bi-Levelモード
              var epap = this.targetData.prescriptionItems.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var ipap = this.targetData.prescriptionItems.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epap.displayOrder,
                    msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(epap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「EPAP」以下の値を設定してください。\n",
                  });
                }
              }
              var flex = this.targetData.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if(flex.value=="1"){
                // 20251128_緊急対応
                // Bi-Flex
                // if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                //   if(Number(epap.value) == Number(ipap.value)){
                //     // 「IPAPの値≠EPAPの値」でない場合
                //     errMsg = errMsg + "「EPAP」「IPAP」に異なる値を設定してください。\n"
                //   }
                // }
              }else if(flex.value=="2" || flex.value=="3"){
                // C-Flex
                // C-Flex+
                if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                  if(Number(epap.value) != Number(ipap.value)){
                    // 「IPAPの値=EPAPの値」でない場合
                    correlationList.push({
                      displayOrder: epap.displayOrder,
                      msg: "「EPAP」「IPAP」に同じ値を設定してください。\n",
                    });
                  }
                }
              }
            }else if(this.targetData.mode == "1"){
              // Auto Bi-Levelモード
              var epapMin = this.targetData.prescriptionItems.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var ipapMax = this.targetData.prescriptionItems.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epapMin.value) > Number(ipapMax.value)){
                  // "EPAP最小圧【hPa(cmH2O)】" <= "IPAP最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epapMin.displayOrder,
                    msg: "「EPAP最小圧」に「IPAP最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              var psMin = this.targetData.prescriptionItems.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var psMax = this.targetData.prescriptionItems.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(psMin.value) > Number(psMax.value)){
                  // "PS最小圧【hPa(cmH2O)】" <= "PS最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: psMin.displayOrder,
                    msg: "「PS最小圧」に「PS最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                // QA267_DS BiPAP AutoにおいてminEPAPとmaxIPAPの差分とPSの設定範囲の関係性が考慮できていない
                if (Number(ipapMax.value) - Number(epapMin.value) < Number(psMax.value)) {
                  // "IPAP最大圧【hPa(cmH2O)"-"EPAP最小圧【hPa(cmH2O)】" >= "PS最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: psMax.displayOrder,
                    msg: "「PS最大圧」に「IPAP最大圧」-「EPAP最小圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(epapMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「EPAP最小圧」以下の値を設定してください。\n",
                  });
                }
              }
              // QA474_処方値関連残
              // Bipap（Auto Bi-Levelモード）IPAP＝EPAPのときPS最大圧、PS最小圧は0－0で非活性とする。
              if (errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 ) {
                if((Number(epapMin.value) == Number(ipapMax.value)) && (Number(psMax.value) != 0 || Number(psMin.value) != 0)){
                  correlationList.push({
                    displayOrder: psMax.displayOrder,
                    msg: "「IPAP最大圧」と「EPAP最小圧」が同じ値の場合、「PS最大圧」と「PS最小圧」に0を設定してください。\n",
                  });
                }
              }
              var flex = this.targetData.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if(flex.value=="1"){
                // 20251128_緊急対応
                // Bi-Flex
                // if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                //   if(Number(psMin.value)==0 && Number(psMax.value)==0){
                //     // 「PS最小圧≠0 または PS最大圧≠0 」でない場合
                //     errMsg = errMsg + "「PS最小圧」または「PS最大圧」に0以外の値を設定してください。\n"
                //   }
                // }
              }else if(flex.value=="2"){
                // C-Flex
                if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                  if(Number(psMin.value)!=0 || Number(psMax.value)!=0){
                    // 「PS最小圧=0」且つ「PS最大圧=0」でない場合
                    correlationList.push({
                      displayOrder: psMin.displayOrder,
                      msg: "「PS最小圧」「PS最大圧」に0を設定してください。\n",
                    });
                  }
                }
              }
            }
            // Flex設定,Flexタイプの相関チェック
            // Flex設定
            var flex = this.targetData.prescriptionItems.find(val => val.displayOrder == 13)
            // Flex設定ロック
            var flexLock = this.targetData.prescriptionItems.find(val => val.displayOrder == 14)
            // Flexタイプ
            var flexType
            if (this.targetData.mode == 1) { // Auto Bi-Levelモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 12)
            } else if (this.targetData.mode == 4) { // CPAPモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 10)
            } else if (this.targetData.mode == 8) { // Bi-Levelモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 11)
            }
            // Flexタイプ:0、Flex設定:値がある場合
            if (flexType.value == "0" && flex.value != "") {
              correlationList.push({
                displayOrder: flexType.displayOrder,
                msg: "FlexタイプまたはFlex設定どちらかを選択してください\n",
              });
            }
            if (this.targetData.mode == 1 || this.targetData.mode == 8) {
              // QA474_処方値関連残
              // Bipap（Auto Bi-Levelモード、Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
              if (flexType.value == "0" && flexLock.value != "") {
                correlationList.push({
                  displayOrder: flexType.displayOrder,
                  msg: "FlexタイプまたはFlex設定ロックどちらかを選択してください\n",
                });
              }
            }
            break;
          case 5:
            // エスボックス バイスタルク
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "4"){
              // CPAPモード
              // "ランプ開始圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
            }else if(this.targetData.mode == "1"){
              // Auto CPAPモード
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("ランプ開始圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプ開始圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプ開始圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
          case 6:
            // プリズマ ライン (prisma25S)
            if(this.targetData.mode == "1"){
              // APAPモード
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.targetData.mode == "7"){
              // Sモード
              var epap = this.targetData.prescriptionItems.find(val => val.displayName == "EPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var ipap = this.targetData.prescriptionItems.find(val => val.displayName == "IPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP圧【hPa（cmH2O)】") == -1 && errorMsg.indexOf("IPAP圧【hPa（cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP圧【hPa（cmH2O)】" <= "IPAP圧【hPa（cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epap.displayOrder,
                    msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.targetData.mode == "9"){
              // autoSモード
              var pdiffMin = this.targetData.prescriptionItems.find(val => val.displayName == "PDIFF min 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pdiffMax = this.targetData.prescriptionItems.find(val => val.displayName == "PDIFF max 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("PDIFF min 圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PDIFF max 圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pdiffMin.value) > Number(pdiffMax.value)){
                  // "PDIFF min 圧【hPa(cmH2O)】" <= "PDIFF max 圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: pdiffMin.displayOrder,
                    msg: "「PDIFF min 圧」に「PDIFF max 圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
        }
      }

      /** 加湿器、通信モジュール */
      const validateResult = await child.$validator.validateAll()
      // QA427_エラー内容を項目ごとに取得
      const errorList = child.$validator.errors.items;

      // 必須チェック結果をdisplayOrderとメッセージのみにする
      const sortList = errorList.map(val => {
        const match = val.field.match(/_(\d+)$/);
        let num = match ? Number(match[1]) : null;
        if (val.field.includes("form2")) {          // 本体
          num = num + 1;
        } else if (val.field.includes("form3_2")) { // モデム
          num = num + 200;
        } else if (val.field.includes("form3")) {   // 加湿器
          num = num + 100;
        }
        return {
          displayOrder: num,
          msg: val.msg + "。\n",
        };
      });

      var moistInfo = document.getElementsByClassName("moistInfo");
      var moistInfoResult = this.selfMadeValidation(moistInfo);
      if (moistInfoResult.isError) {
        sortList.push({
          displayOrder: 150,
          msg: moistInfoResult.msg,
        });
      }
      var moduleInfo = document.getElementsByClassName("moduleInfo");
      var moduleInfoResult = this.selfMadeValidation(moduleInfo);
      if (moduleInfoResult.isError) {
        sortList.push({
          displayOrder: 250,
          msg: moduleInfoResult.msg,
        });
      }

      // 必須チェックと相関チェックのエラーメッセージを統合してdisplayOrder順に並び替え
      sortList.push(...correlationList);
      sortList.sort((first, second) => first.displayOrder - second.displayOrder);

      // 表示するメッセージ変数に格納
      for (var i = 0; i < sortList.length; i++) {
        const error = sortList[i];
        errorMsg = errorMsg + error.msg;
      }

      /** マスク */
      if(!this.targetData.maskItemCode){
        errorMsg = errorMsg + "「マスク」は必須項目です。\n"
      }else{
        //マスク枠内各項目必須チェック
        if(!this.targetData.maskType){// マスク：種類
          errorMsg = errorMsg + "「マスク：種類」は必須項目です。\n"
        }
        if(!this.targetData.cushionSize){// マスク：クッションサイズ
          errorMsg = errorMsg + "「マスク：クッションサイズ」は必須項目です。\n"
        }
        if(!this.targetData.frameSize){// マスク：フレームサイズ
          errorMsg = errorMsg + "「マスク：フレームサイズ」は必須項目です。\n"
        }
        if(!this.targetData.fixingMethod){// マスク：固定方法
          errorMsg = errorMsg + "「マスク：固定方法」は必須項目です。\n"
        }
      }

      /** 納品先情報 */
      var deliveryInfo = document.getElementsByClassName("deliveryInfo");
      var deliveryInfoResult = this.selfMadeValidation(deliveryInfo);
      errorMsg = errorMsg + deliveryInfoResult.msg;

      /** 返却情報 */
      // 機器返却がある場合は返却先は必須
      if(this.targetData.machineReturn){
        var collectionDestination1 = document.getElementById("collectionDestination1");
        var collectionDestination2 = document.getElementById("collectionDestination2");
        collectionDestination1.style["color"] = "";
        collectionDestination2.style["color"] = "";
        if(!(this.targetData.collectionDestination+"") || this.targetData.collectionDestination == null){
          // 機器返却がある処方変更で、返却先未設定
          errorMsg = errorMsg + "「返却先」は必須項目です。\n"
          collectionDestination1.style["color"] = "red";
          collectionDestination2.style["color"] = "red";
        }
      }

      var returnInfo = document.getElementsByClassName("returnInfo");
      var returnInfoResult = this.selfMadeValidation(returnInfo);
      errorMsg = errorMsg + returnInfoResult.msg;

      /** オーダー情報 */
      var orderInfo = document.getElementsByClassName("orderInfo");
      var orderInfoResult = this.selfMadeValidation(orderInfo);
      errorMsg = errorMsg + orderInfoResult.msg;

      if (!validateResult || errorMsg) {
        this.showErrorMessage(errorMsg)
        return
      }
      if (this.targetData.estimateDetailCode) {
        // QA427_エラーメッセージを一気に表示するため末尾へ移動
        for(let estimate of this.targetData.estimateDetailCode){
          if(child.directionsItemList && child.directionsItemList.length > 0){
            let target = child.directionsItemList.find(val => val.itemCode == estimate.itemCode)
            // 出荷指示・回収指示フラグを見積情報に格納する
            if(target){
              estimate.shippingInstructionsFlg = target.shippingInstructionsFlg ? target.shippingInstructionsFlg : false
              estimate.collectionInstructionsFlg = target.collectionInstructionsFlg ? target.collectionInstructionsFlg : false
            }
          }
        }
        if(child.saveEstimateDetail && child.saveEstimateDetail.length > 0){
          //指示書未選択分を見積情報に格納
          for(let saveEstimate of child.saveEstimateDetail){
            //指示書未選択分
            if(saveEstimate.estimateCode && !saveEstimate.itemCode){
              this.targetData.estimateDetailCode.push(saveEstimate)
              continue
            }
            //モデム同時交換 見積が入っていないもののみ
            let moduleTarget = child.directionsItemList.find(val => (!val.estimateCode) && (val.itemCode == saveEstimate.itemCode))
            if(moduleTarget){
              this.targetData.estimateDetailCode.push(saveEstimate)
              continue
            }
          }
        }
      }

      var excuteApi = this.setCpapRequestSavePOST;
      var successCallBack = this.setCpapRequestSavePOSTSuccess;
      var errorCallBack = this.setCpapRequestSavePOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    cancelSave: async function() {
      // 申請保存(処方中止)
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      var excuteApi = this.setCpapRequestSavePOST;
      var successCallBack = this.setCpapRequestSavePOSTSuccess;
      var errorCallBack = this.setCpapRequestSavePOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    transFerSave: async function() {
      // 申請保存(転院)
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      var excuteApi = this.setCpapRequestSavePOST;
      var successCallBack = this.setCpapRequestSavePOSTSuccess;
      var errorCallBack = this.setCpapRequestSavePOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    setCpapRequestSavePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.targetData));
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      
      // 無の場合は、品目コード、シリアルを初期化
      obj.moistItemCode = !obj.useMoist ? "" : obj.moistItemCode
      obj.moistSerial = !obj.useMoist ? "" : obj.moistSerial
      obj.moduleItemCode = !obj.useModule ? "" : obj.moduleItemCode
      obj.moduleSerial = !obj.useModule ? "" : obj.moduleSerial

      // 各パラメータの型変換
      obj.expectedReturnDate = obj.expectedReturnDate ? obj.expectedReturnDate.replace(/-/g, "/") : ""
      obj.transferDate = obj.transferDate ? obj.transferDate.replace(/-/g, "/") :""
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") : ""
      obj.billingStartDate = obj.billingStartDate ? obj.billingStartDate.replace(/-/g, "/") : ""
      obj.shippingDate = obj.senderType==1 && obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.appointedDeliveryDate = obj.appointedDeliveryDate ? obj.appointedDeliveryDate.replace(/-/g, "/") : ""
      obj.specifiedDeliveryDate = obj.specifiedDeliveryDate ? obj.specifiedDeliveryDate.replace(/-/g, "/") : ""
      return client.apis.internalCpap.setCpapRequestSavePOST({
        body:obj
      });
    },
    setCpapRequestSavePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    confirm: async function() {
      // 申請確定
      var child = this.$refs.detailEdit;
      var errorMsg = "";
      this.targetData.mode = child.getMode()

      /** 品目情報 */
      var setItem = child.cpapSetItems.find(val => val.cpapItemCode == this.targetData.model)
      var model = this.modelList.find(item => item.reportFormatType == this.targetData.reportFormatType)
      if (this.targetData.estimateDetailCode) {
        let codes = model.itemCodes
        let targets = this.targetData.estimateDetailCode.filter(val => codes.indexOf(val.itemCode) != -1)
        if(targets.length < 1){
          errorMsg = errorMsg + "CPAP機器が選択されていません。\n"
        }else if(targets.length > 1){
          errorMsg = errorMsg + "CPAP機器が複数選択されています。\n"
        }else if(this.targetData.notDirections || this.resume){
          // 仮持出、転院⇒再開の場合
          if(targets && targets.length >= 1){
            if(this.targetData.model != targets[0].itemCode){
              errorMsg = errorMsg + "CPAP機器の品目に一致する見積が選択されていません。\n"
            }
          }
        }

        var moistList = []
        var moduleList = []
        var maskList = []
        var circuitList = []

        for(let item of this.cpapAccessories){
          switch(item.type){
            case "moist":
              moistList.push(item.itemCode)
              break;
            case "module":
              moduleList.push(item.itemCode)
              break;
            case "mask":
            case "flame":
            case "headgear":
            case "maskCushion":
            case "maskHeadgear":
              maskList.push(item.itemCode)
              break;
            case "circuit":
              circuitList.push(item.itemCode)
              break;
          }
        }

        var moistItem = this.targetData.estimateDetailCode.find(item => moistList.indexOf(item.itemCode)!=-1)
        var estimateMoistItem = this.targetData.estimateDetailCode.find(item => item.itemCode == this.targetData.moistItemCode)
        var moduleItem = this.targetData.estimateDetailCode.find(item => moduleList.indexOf(item.itemCode)!=-1)

        if(this.targetData.useMoist && (!moistItem || !estimateMoistItem)){
          errorMsg = errorMsg + "加湿器の品目に一致する見積明細番号が選択されていません。\n"
        }
        if(!this.targetData.useMoist && moistItem){
          errorMsg = errorMsg + "加湿器が有になっていません(見積番号選択済み)\n"
        }
        if(this.targetData.reportFormatType!=3 && this.targetData.reportFormatType!=5 && this.targetData.reportFormatType!=6){
          if(this.targetData.useModule && !moduleItem){
          errorMsg = errorMsg + "通信モジュールの品目に一致する見積明細番号が選択されていません。\n"
          }
          if(!this.targetData.useModule && moduleItem){
          errorMsg = errorMsg + "通信モジュールが有になっていません(見積番号選択済み)\n"
          }
        }

        let oldCpapItemCode=""
        let oldMoistItemCode=""
        let oldModuleItemCode=""
        let oldCpapSerial=""
        let oldMoistSerial=""
        let oldModuleSerial=""
        // QA345① 本体出荷指示チェックフラグ
        var modelShippingInstructionsFlg = false
        if(this.targetData.comparisonDatas){
          let oldCpap = this.targetData.comparisonDatas.find(val => val.itemName == "model")
          let oldMoist = this.targetData.comparisonDatas.find(val => val.itemName == "moistItemCode")
          let oldModule = this.targetData.comparisonDatas.find(val => val.itemName == "moduleItemCode")
          if(oldCpap) oldCpapItemCode = oldCpap.value
          if(oldMoist) oldMoistItemCode = oldMoist.value
          if(oldModule) oldModuleItemCode = oldModule.value
          // QA471_預託・仮持出の出荷指示バリデーションの追加
          let oldCpapSerials = this.targetData.comparisonDatas.find(val => val.itemName == "serial")
          let oldMoistSerials = this.targetData.comparisonDatas.find(val => val.itemName == "moistSerial")
          let oldModuleSerials = this.targetData.comparisonDatas.find(val => val.itemName == "moduleSerial")
          if(oldCpapSerials) oldCpapSerial = oldCpapSerials.value
          if(oldMoistSerials) oldMoistSerial = oldMoistSerials.value
          if(oldModuleSerials) oldModuleSerial = oldModuleSerials.value
        }

        for(let estimate of this.targetData.estimateDetailCode){
          if(child.directionsItemList && child.directionsItemList.length > 0){
            let target = child.directionsItemList.find(val => val.itemCode == estimate.itemCode)  

            // 出荷指示・回収指示フラグを見積情報に格納する
            if(target){
              estimate.shippingInstructionsFlg = target.shippingInstructionsFlg ? target.shippingInstructionsFlg : false
              estimate.collectionInstructionsFlg = target.collectionInstructionsFlg ? target.collectionInstructionsFlg : false
              //『見積選択』あり、『回収指示』にチェックがある場合 20231128
              if(!target.shippingInstructionsFlg && target.collectionInstructionsFlg && estimate.estimateCode){
                errorMsg = errorMsg + "『回収指示』のある機器の『見積選択』を取り消してください。\n"
              }
              //　シリアル変更時のチェックエラー 出荷指示・回収指示があり、見積紐づけ無し
              if(!estimate.estimateCode && target.shippingInstructionsFlg && target.collectionInstructionsFlg){
                if(this.targetData.notDirections || this.targetData.depositUseFlag){
                  errorMsg = errorMsg + "『レンタル処理指示』『回収指示』のあるシリアル変更機器の『見積選択』を選択してください。\n"
                }else{
                  errorMsg = errorMsg + "『出荷指示』『回収指示』のあるシリアル変更機器の『見積選択』を選択してください。\n"
                }
              }
            }
            //指示フラグチェック
            //CPAP本体
            if(estimate.itemCode == this.targetData.model){
              if(target){
                modelShippingInstructionsFlg = target.shippingInstructionsFlg ? true : false
                //仮持出の場合
                if(this.targetData.notDirections){
                  //レンタル処理指示と見積が選択されている場合
                  if(target.shippingInstructionsFlg && estimate.estimateCode){
                    if(target.tempDeviceId =="" && !this.resume){
                      errorMsg = errorMsg + "本体の品目に一致する機器が選択されていません。\n"
                      continue;
                    }
                  }
                  // QA471_預託・仮持出の出荷指示バリデーションの追加
                  // シリアル変更のとき
                  if (this.targetKind == 2) {
                    if (oldCpapSerial != "" && oldCpapSerial != this.targetData.serial) {
                      // 出荷指示チェックが入っていなかったら
                      if (!target.shippingInstructionsFlg) {
                        errorMsg = errorMsg + "本体の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                }
                //預託の場合
                if(this.targetData.depositUseFlag){
                  //レンタル処理指示と見積が選択されている場合
                  if(target.shippingInstructionsFlg && estimate.estimateCode){
                    if(!target.depositUseOrderId){
                      errorMsg = errorMsg + "本体のオーダーが選択されていません。\n"
                      continue;
                    }
                  }
                  // QA471_預託・仮持出の出荷指示バリデーションの追加
                  // シリアル変更のとき
                  if (this.targetKind == 2) {
                    if (oldCpapSerial != "" && oldCpapSerial != this.targetData.serial) {
                      // 出荷指示チェックが入っていなかったら
                      if (!target.shippingInstructionsFlg) {
                        errorMsg = errorMsg + "本体の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                }
                // 新規処方、仮持出新規、再開申込みの場合
                if(this.targetKind == 1 || this.targetKind == 5 || this.targetKind == 7){
                  if(!target.shippingInstructionsFlg && estimate.estimateCode){
                    if(this.targetData.notDirections || this.targetData.depositUseFlag){
                      errorMsg = errorMsg + "本体の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                      continue;
                    }else{
                      errorMsg = errorMsg + "本体の『出荷指示』チェック後『見積選択』を行ってください。\n"
                      continue;
                    }
                  } else if (target.shippingInstructionsFlg && estimate.estimateCode) {
                    // 転院後再開の場合の相関チェック
                    if (child && this.resume) {
                      // CPAP本体の仮持出オーダーが選択済みかチェック
                      if(target.tempDeviceId == "" && !child.resumeExchangeCheck(this.targetData.model)) {
                        errorMsg = errorMsg + "本体の品目に一致する機器が選択されていません。\n"
                        continue;
                      }
                    }
                  }
                }else{
                  //機種交換時
                  if(this.targetData.model != oldCpapItemCode){
                    // シリアル交換不可
                    if(estimate.shippingInstructionsFlg && estimate.collectionInstructionsFlg){
                      errorMsg = errorMsg + "本体シリアル交換不可。\n"
                    }
                    // 新器械の出荷指示がなく見積のみ設定されている場合
                    if(!estimate.shippingInstructionsFlg && estimate.estimateCode){
                      if(this.targetData.notDirections || this.targetData.depositUseFlag){
                        errorMsg = errorMsg + "本体の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }else{
                        errorMsg = errorMsg + "本体の『出荷指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                    // 旧器械の回収指示がない場合
                    if(oldCpapItemCode != ""){
                      let oldTarget = child.directionsItemList.find(val => val.itemCode == oldCpapItemCode)
                      if(oldTarget){
                        if(!oldTarget.collectionInstructionsFlg){
                          errorMsg = errorMsg + "本体返却機器の「回収指示」チェックがされていません。\n"
                          continue;
                        }
                      }  
                    }
                  } else {
                    // QA345①本体の出荷指示チェックあり、かつ旧本体の回収指示チェックがない場合バリデーションをかける
                    // シリアル交換の場合のバリデーションを追加
                    if (estimate.shippingInstructionsFlg && !estimate.collectionInstructionsFlg) {
                      errorMsg = errorMsg + "本体返却機器の「回収指示」チェックがされていません。\n"
                      continue;
                    }
                  }
                }
              }
            }
            //加温加湿器
            if(estimate.itemCode == this.targetData.moistItemCode){
              if(target){
                //仮持出の場合
                if(this.targetData.notDirections){
                  //レンタル処理指示と見積が選択されている場合
                  if(target.shippingInstructionsFlg && estimate.estimateCode){
                    if(target.tempDeviceId =="" && !this.resume){
                      errorMsg = errorMsg + "加湿器の品目に一致する機器が選択されていません。\n"
                      continue;
                    }
                  }
                  // QA471_預託・仮持出の出荷指示バリデーションの追加
                  // シリアル変更のとき
                  if (this.targetKind == 2) {
                    if (oldMoistSerial != "" && oldMoistSerial != this.targetData.moistSerial) {
                      // 出荷指示チェックが入っていなかったら
                      if (!target.shippingInstructionsFlg) {
                        errorMsg = errorMsg + "加湿器の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                }
                //預託の場合
                if(this.targetData.depositUseFlag){
                  //レンタル処理指示と見積が選択されている場合
                  if(target.shippingInstructionsFlg && estimate.estimateCode){
                    if(!target.depositUseOrderId){
                      errorMsg = errorMsg + "加湿器のオーダーが選択されていません。\n"
                      continue;
                    }
                  }
                  // QA471_預託・仮持出の出荷指示バリデーションの追加
                  // シリアル変更のとき
                  if (this.targetKind == 2) {
                    if (oldMoistSerial != "" && oldMoistSerial != this.targetData.moistSerial) {
                      // 出荷指示チェックが入っていなかったら
                      if (!target.shippingInstructionsFlg) {
                        errorMsg = errorMsg + "加湿器の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                }
                // 新規処方、仮持出新規、再開申込みの場合
                if(this.targetKind == 1 || this.targetKind == 5 || this.targetKind == 7){
                  if(!target.shippingInstructionsFlg && estimate.estimateCode){
                    if(this.targetData.notDirections || this.targetData.depositUseFlag){
                      errorMsg = errorMsg + "加湿器の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                      continue;
                    }else{
                      errorMsg = errorMsg + "加湿器の『出荷指示』チェック後『見積選択』を行ってください。\n"
                      continue;
                    }
                  } else if (target.shippingInstructionsFlg && estimate.estimateCode) {
                    // 転院後再開の場合の相関チェック
                    if (child && this.resume) {
                      // 加湿器有りの場合、仮持出オーダーが選択済みかチェック
                      if(this.targetData.useMoist){
                        if(setItem.moist){
                          for(let moistItem of setItem.moist){
                            if(target.tempDeviceId == "" && !child.resumeExchangeCheck(moistItem.itemCode)) {
                              errorMsg = errorMsg + "加湿器の品目に一致する機器が選択されていません。\n"
                              break;
                            }
                          }
                        } else {
                          if(target.tempDeviceId == "" && !child.resumeExchangeCheck(setItem.moistItemCode)) {
                            errorMsg = errorMsg + "加湿器の品目に一致する機器が選択されていません。\n"
                            continue;
                          }
                        }
                      }
                    }
                  }
                }else{
                  //追加時
                  if(oldMoistItemCode == "" && this.targetData.moistItemCode !=""){
                    // シリアル交換不可
                    if(estimate.shippingInstructionsFlg && estimate.collectionInstructionsFlg){
                      errorMsg = errorMsg + "加湿器シリアル交換不可。\n"
                    }
                    // 加湿器の出荷指示がなく見積のみ設定されている場合
                    if(!estimate.shippingInstructionsFlg && estimate.estimateCode){
                      if(this.targetData.notDirections || this.targetData.depositUseFlag){
                        errorMsg = errorMsg + "加湿器の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }else{
                        errorMsg = errorMsg + "加湿器の『出荷指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                  //変更時
                  if(oldMoistItemCode != "" && this.targetData.moistItemCode !=""){
                    if(oldMoistItemCode != this.targetData.moistItemCode){
                      // シリアル交換不可
                      if(estimate.shippingInstructionsFlg && estimate.collectionInstructionsFlg){
                        errorMsg = errorMsg + "加湿器シリアル交換不可。\n"
                      }
                      // 加湿器の出荷指示がなく見積のみ設定されている場合
                      if(!estimate.shippingInstructionsFlg && estimate.estimateCode){
                        if(this.targetData.notDirections || this.targetData.depositUseFlag){
                          errorMsg = errorMsg + "加湿器の『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                          continue;
                        }else{
                          errorMsg = errorMsg + "加湿器の『出荷指示』チェック後『見積選択』を行ってください。\n"
                          continue;
                        }
                      }
                      // 旧器械の回収指示がない場合
                      if(oldMoistItemCode != ""){
                        let oldTarget = child.directionsItemList.find(val => val.itemCode == oldMoistItemCode)
                        if(oldTarget){
                          if(!oldTarget.collectionInstructionsFlg){
                            errorMsg = errorMsg + "加湿器返却機器の「回収指示」チェックがされていません。\n"
                            continue;
                          }
                        }  
                      }
                    }
                  }
                }
              }
            }
            //通信モジュール
            if(estimate.itemCode == this.targetData.moduleItemCode){
              if(target){
                //仮持出の場合
                if(this.targetData.notDirections){
                  //レンタル処理指示と見積が選択されている場合
                  if(target.shippingInstructionsFlg && estimate.estimateCode){
                    if(target.tempDeviceId =="" && !this.resume){
                      errorMsg = errorMsg + "通信モジュールの品目に一致する機器が選択されていません。\n"
                      continue;
                    }
                  }
                  // QA471_預託・仮持出の出荷指示バリデーションの追加
                  // シリアル変更のとき
                  if (this.targetKind == 2) {
                    if (oldModuleSerial != "" && oldModuleSerial != this.targetData.moduleSerial) {
                      // 出荷指示チェックが入っていなかったら
                      if (!target.shippingInstructionsFlg) {
                        errorMsg = errorMsg + "モデムの『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                }
                //預託の場合
                if(this.targetData.depositUseFlag){
                  //レンタル処理指示と見積が選択されている場合
                  if(target.shippingInstructionsFlg && estimate.estimateCode){
                    if(!target.depositUseOrderId){
                      errorMsg = errorMsg + "モデムのオーダーが選択されていません。\n"
                      continue;
                    }
                  }
                  // QA471_預託・仮持出の出荷指示バリデーションの追加
                  // シリアル変更のとき
                  if (this.targetKind == 2) {
                    if (oldModuleSerial != "" && oldModuleSerial != this.targetData.moduleSerial) {
                      // 出荷指示チェックが入っていなかったら
                      if (!target.shippingInstructionsFlg) {
                        errorMsg = errorMsg + "モデムの『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                }
                // 新規処方、仮持出新規、再開申込みの場合
                if(this.targetKind == 1 || this.targetKind == 5 || this.targetKind == 7){
                  if(!target.shippingInstructionsFlg && estimate.estimateCode){
                    if(this.targetData.notDirections || this.targetData.depositUseFlag){
                      errorMsg = errorMsg + "モデムの『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                      continue;
                    }else{
                      errorMsg = errorMsg + "モデムの『出荷指示』チェック後『見積選択』を行ってください。\n"
                      continue;
                    }
                  } else if (target.shippingInstructionsFlg && estimate.estimateCode) {
                    // 転院後再開の場合の相関チェック
                    if (child && this.resume) {
                      // 通信モジュール有りの場合、仮持出オーダーが選択済みかチェック
                      if(this.targetData.useModule && setItem.module){
                        for(let moduleItem of setItem.module){
                          if(this.targetData.moduleItemCode && this.targetData.moduleItemCode != moduleItem.itemCode) continue
                          if(target.tempDeviceId == "" && !child.resumeExchangeCheck(moduleItem.itemCode)) {
                            errorMsg = errorMsg + "通信モジュールの品目に一致する機器が選択されていません。\n"
                            break;
                          }
                        }
                      }
                    }
                  }
                }else{
                  //追加時
                  if(oldModuleItemCode == "" && this.targetData.moduleItemCode !=""){
                    // シリアル交換不可
                    if(estimate.shippingInstructionsFlg && estimate.collectionInstructionsFlg){
                      errorMsg = errorMsg + "通信モジュールシリアル交換不可。\n"
                    }
                    // モデムの出荷指示がなく見積のみ設定されている場合
                    if(!estimate.shippingInstructionsFlg && estimate.estimateCode){
                      if(this.targetData.notDirections || this.targetData.depositUseFlag){
                        errorMsg = errorMsg + "モデムの『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }else{
                        errorMsg = errorMsg + "モデムの『出荷指示』チェック後『見積選択』を行ってください。\n"
                        continue;
                      }
                    }
                  }
                  //変更時
                  if(oldModuleItemCode != "" && this.targetData.moduleItemCode !=""){
                    if(oldModuleItemCode != this.targetData.moduleItemCode){
                      // シリアル交換不可
                      if(estimate.shippingInstructionsFlg && estimate.collectionInstructionsFlg){
                        errorMsg = errorMsg + "通信モジュールシリアル交換不可。\n"
                      }
                      // モデムの出荷指示がなく見積のみ設定されている場合
                      if(!estimate.shippingInstructionsFlg && estimate.estimateCode){
                        if(this.targetData.notDirections || this.targetData.depositUseFlag){
                          errorMsg = errorMsg + "モデムの『レンタル処理指示』チェック後『見積選択』を行ってください。\n"
                          continue;
                        }else{
                          errorMsg = errorMsg + "モデムの『出荷指示』チェック後『見積選択』を行ってください。\n"
                          continue;
                        }
                      }
                      // 旧器械の回収指示がない場合
                      if(oldModuleItemCode != ""){
                        let oldTarget = child.directionsItemList.find(val => val.itemCode == oldModuleItemCode)
                        if(oldTarget){
                          if(!oldTarget.collectionInstructionsFlg){
                            errorMsg = errorMsg + "モデム返却機器の「回収指示」チェックがされていません。\n"
                            continue;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        // QA345①本体の出荷指示チェックあり、かつ旧モデムの回収指示チェックがない場合バリデーションをかける
        // 本体シリアル交換時、モデム同時交換の場合のバリデーションを追加
        if (this.targetKind == 2 && modelShippingInstructionsFlg) {
          if (oldModuleItemCode && oldModuleItemCode == this.targetData.moduleItemCode) {
            let oldTarget = child.directionsItemList.find(val => val.itemCode == oldModuleItemCode)
            if (oldTarget) {
              if (!oldTarget.collectionInstructionsFlg) {
                errorMsg = errorMsg + "モデム返却機器の「回収指示」チェックがされていません。\n"
              }
            }
          }
        }
        // QA427_エラーメッセージを一気に表示するためfor文外へ移動
        if(child.directionsItemList && child.directionsItemList.length > 0){
          //加湿器削除時
          if(oldMoistItemCode != "" && !this.targetData.useMoist){
            // 旧器械の回収指示がない場合
            let oldTarget = child.directionsItemList.find(val => val.itemCode == oldMoistItemCode)
            if(oldTarget){
              if(!oldTarget.collectionInstructionsFlg){
                errorMsg = errorMsg + "加湿器返却機器の「回収指示」チェックがされていません。\n"
              }
            }  
          }
          //モデム削除時
          if(oldModuleItemCode != "" && !this.targetData.useModule){
            // 旧器械の回収指示がない場合
            let oldTarget = child.directionsItemList.find(val => val.itemCode == oldModuleItemCode)
            if(oldTarget){
              if(!oldTarget.collectionInstructionsFlg){
                errorMsg = errorMsg + "モデム返却機器の「回収指示」チェックがされていません。\n"
              }
            }  
          }
          //モデム削除時(Go以外⇒Go)
          if((oldModuleItemCode != "") && (oldCpapItemCode != "RJPG500S16") && (this.targetData.model == "RJPG500S16")){
            // 旧器械の回収指示がない場合
            let oldTarget = child.directionsItemList.find(val => val.itemCode == oldModuleItemCode)
            if(oldTarget){
              if(!oldTarget.collectionInstructionsFlg){
                errorMsg = errorMsg + "モデム返却機器の「回収指示」チェックがされていません。\n"
              }
            }  
          }
        }
        // 請求先コード、得意先コードチェック
        // CPAP本体情報取得
        let checkTarget = this.targetData.estimateDetailCode.filter(val => {return val.shippingInstructionsFlg == true})
        if(checkTarget.length > 0){
          let cpapTarget = checkTarget[0]
          let hospitalCode = ""
          let billingDestinationCode = ""
          if(cpapTarget){
            hospitalCode = cpapTarget.hospitalCode
            billingDestinationCode = cpapTarget.billingDestinationCode
            //得意先コードチェック
            let hospitalCodeCheck = checkTarget.filter(val => {return val.hospitalCode && (val.hospitalCode != hospitalCode)})
            //請求先コードチェック
            let billingDestinationCodeCheck = checkTarget.filter(val => {return val.billingDestinationCode && (val.billingDestinationCode != billingDestinationCode)})
            if(hospitalCodeCheck.length != 0 && billingDestinationCodeCheck.length == 0){
              errorMsg = errorMsg + "各品目で選択されている見積の請求先コードが一致していません。\n" + "すべての品目で同じ請求先コードになるように見積を選択しなおしてください。\n"
            }
            if(hospitalCodeCheck.length == 0 && billingDestinationCodeCheck.length !=  0){
              errorMsg = errorMsg + "各品目で選択されている見積の医療機関コードが一致していません。\n" + "すべての品目で同じ医療機関コードになるように見積を選択しなおしてください。\n"
            }
            if(hospitalCodeCheck.length != 0 && billingDestinationCodeCheck.length !=  0){
              errorMsg = errorMsg + "各品目で選択されている見積の請求先・医療機関コードが一致していません。\n" + "すべての品目で同じ請求先・医療機関コードになるように見積を選択しなおしてください。\n"
            }
          }
        }
        //預託機の場合、マスク、回路のチェックなし
        if(!this.targetData.depositUseFlag){
          // マスク見積の制御 20231130
          let maskTarget = child.directionsItemList.filter(item => maskList.indexOf(item.itemCode)!=-1)

          if(maskTarget){
            //出荷指示があり見積未選択の場合
            let MaskShipping = maskTarget.filter(item => (item.estimateCode == "") && (item.shippingInstructionsFlg == true))

            if(MaskShipping.length > 0){
              errorMsg = errorMsg + "マスクの見積が選択されていません。\n"
            }
          }
          // 回路見積の制御 20231130
          let circuitTarget = child.directionsItemList.filter(item => circuitList.indexOf(item.itemCode)!=-1)
          if(circuitTarget){
            //出荷指示があり見積未選択の場合
            let CircuitShipping = circuitTarget.filter(item => (item.estimateCode == "") && (item.shippingInstructionsFlg == true))
            
            if(CircuitShipping.length > 0){
              errorMsg = errorMsg + "回路の見積が選択されていません。\n"
            }
          }
        }
        //仮持出　マスク、回路
        //出荷フラグが入っている場合は機器を選択されている必要がある
        if(this.targetData.notDirections || (this.resume && this.targetKind == 5)){
          // 出荷指示フラグあり
          let shippingTarget = this.targetData.estimateDetailCode.filter(val => {return val.shippingInstructionsFlg == true})
          let maskItems = shippingTarget.filter(item => maskList.indexOf(item.itemCode)!=-1)
          let circuitItems = shippingTarget.filter(item => circuitList.indexOf(item.itemCode)!=-1)
          //機器選択リスト
          for(let maskItem of maskItems){
            let UnselectedMaskItem = this.targetData.provisionalTakenOutItems.filter(item => item.itemCode == maskItem.itemCode)
            if(UnselectedMaskItem.length == 0){
              errorMsg = errorMsg + "マスクの品目に一致する機器が選択されていません。\n"
              break;
            }
          }
          for(let circuitItem of circuitItems){
            let UnselectedCircuitItem = this.targetData.provisionalTakenOutItems.filter(item => item.itemCode == circuitItem.itemCode)
            if(UnselectedCircuitItem.length == 0){
              errorMsg = errorMsg + "回路の品目に一致する機器が選択されていません。\n"
              break;
            }
          }
        }
      }

      /** 医療機関情報 */
      var hospitalInfo = document.getElementsByClassName("hospitalInfo");
      var hospitalInfoResult = this.selfMadeValidation(hospitalInfo);
      errorMsg = errorMsg + hospitalInfoResult.msg;

      /** 患者情報 */
      var patientInfo = document.getElementsByClassName("patientInfo");
      var patientInfoResult = this.selfMadeValidation(patientInfo);
      errorMsg = errorMsg + patientInfoResult.msg;

      // 電話番号は携帯か自宅のどちらかが必須
      var phoneNumber = document.getElementById("phoneNumber");
      var mobilePhone = document.getElementById("mobilePhone");
      phoneNumber.style["border-color"] = "";
      mobilePhone.style["border-color"] = "";
      if(!this.targetData.patient.phoneNumber && !this.targetData.patient.mobilePhone){
        errorMsg = errorMsg + "「連絡先（携帯電話）」「連絡（自宅・その他）」いずれかは必須項目です。\n"
        phoneNumber.style["border-color"] = "red";
        mobilePhone.style["border-color"] = "red";
      }

      /** 装置情報 */
      var modelInfo = document.getElementsByClassName("modelInfo");
      var modelInfoResult = this.selfMadeValidation(modelInfo);
      errorMsg = errorMsg + modelInfoResult.msg;

      /** 設定情報 相関チェック */
      var correlationList = [];
      if (this.targetData.mode) {
        switch(model.reportFormatType){
          case 1:
            // ドリームステーションAuto
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "1"){
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else{
              var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }

            // Flex設定、Flexタイプの相関チェック
            // Flex設定
            var flex = this.targetData.prescriptionItems.find(val => val.displayOrder == 9)
            // Flexタイプ
            var flexType
            if (this.targetData.mode == 1) { // Auto CPAPモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 8)
            } else if (this.targetData.mode == 4) { // CPAPモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 7)
            }
            // Flexタイプ:0、Flex設定:値がある場合
            if (flexType.value == "0" && flex.value != "") {
              correlationList.push({
                displayOrder: flexType.displayOrder,
                msg: "FlexタイプまたはFlex設定どちらかを選択してください\n",
              });
            }

            // 加湿モード、回路温度設定の相関チェック
            // 加温加湿器
            var moist = this.targetData.prescriptionItems.find(val => val.displayOrder == 24)
            // 加湿モード
            var moistMode = this.targetData.prescriptionItems.find(val => val.displayOrder == 26)
            // 回路温度設定
            var circuit = this.targetData.prescriptionItems.find(val => val.displayOrder == 28)
            // 加温加湿器:1、加湿モード:0または1、回路温度設定:値がある場合
            if (moist.value == "1" && (moistMode.value == "0" || moistMode.value=="1") && circuit.value != "") {
              correlationList.push({
                displayOrder: moistMode.displayOrder,
                msg: "加湿モードまたは回路温度設定どちらかを選択してください\n",
              });
            }
            // QA474_処方値関連残
            // マスクフィットチェックオン且つ出荷元川越を選択した場合、バリデーションを追加する。
            var maskFitCheck = this.targetData.prescriptionItems.find(val => val.displayName == "マスクフィットチェック")
            if (maskFitCheck && maskFitCheck.value) {
              if (maskFitCheck.value == "1" && this.targetData.senderType == "0") {
                // QA513 出荷指示チェックの条件追加
                if (this.targetData.estimateDetailCode) {
                  let targets = this.targetData.estimateDetailCode.find(val => val.itemCode == this.targetData.model)
                  if (targets && targets.shippingInstructionsFlg) {
                    correlationList.push({
                      displayOrder: maskFitCheck.displayOrder,
                      msg: "マスクフィットチェック「OFF」のみ川越直送可能です。\n支店出荷への変更、もしくは設定内容を確認してください。\n",
                    });
                  }
                }
              }
            }
            // QA513 EZ-Start「ON」×川越発送×本体出荷指示チェックがある場合、バリデーションを追加
            var ezStart = this.targetData.prescriptionItems.filter(val=>{ return val.displayName == 'Ez-Start'})
            if (ezStart[0].value == '1' && this.targetData.senderType == '0') {
              if (this.targetData.estimateDetailCode) {
                let targets = this.targetData.estimateDetailCode.find(val => val.itemCode == this.targetData.model)
                if (targets && targets.shippingInstructionsFlg) {
                  correlationList.push({
                    displayOrder: ezStart[0].displayOrder,
                    msg: "EZ-Start「OFF」のみ川越直送可能です。\n支店出荷への変更、もしくは設定内容を確認してください。\n",
                  });
                }
              }
            }
            break;
          case 2:
            // ドリームステーションPro
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
              if(Number(lampStart.value) > Number(pressureCpap.value)){
                // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                correlationList.push({
                  displayOrder: lampStart.displayOrder,
                  msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                });
              }
            }
            //ezStart-on ＆川越出荷
            var ezStart = this.targetData.prescriptionItems.filter(val=>{ return val.displayName==='Ez-Start'})
            if(ezStart[0].value=='1' && this.targetData.senderType=='0'){
              correlationList.push({
                displayOrder: ezStart[0].displayOrder,
                msg: "EZ-Start「OFF」のみ川越直送可能です。\n支店出荷への変更、もしくは設定内容を確認してください。\n",
              });
            }

            // Flex設定,Flexタイプの相関チェック
            // Flexタイプ
            var flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 4)
            // Flex設定
            var flex = this.targetData.prescriptionItems.find(val => val.displayOrder == 5)
            // Flexタイプ:0、Flex設定:値がある場合
            if (flexType.value == "0" && flex.value != "") {
              correlationList.push({
                displayOrder: flexType.displayOrder,
                msg: "FlexタイプまたはFlex設定どちらかを選択してください\n",
              });
            }

            // 加湿モード、回路温度設定の相関チェック
            // 加温加湿器
            var moist = this.targetData.prescriptionItems.find(val => val.displayOrder == 20)
            // 加湿モード
            var moistMode = this.targetData.prescriptionItems.find(val => val.displayOrder == 22)
            // 回路温度設定
            var circuit = this.targetData.prescriptionItems.find(val => val.displayOrder == 24)
            // 加温加湿器:1、加湿モード:0または1、回路温度設定:値がある場合
            if (moist.value == "1" && (moistMode.value == "0" || moistMode.value=="1") && circuit.value != "") {
              correlationList.push({
                displayOrder: moistMode.displayOrder,
                msg: "加湿モードまたは回路温度設定どちらかを選択してください\n",
              });
            }

            break;
          case 3:
            // ドリームステーションGo
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "1"){
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else{
              var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            // Flex設定,Flexタイプの相関チェック
            // Flex設定
            var flex = this.targetData.prescriptionItems.find(val => val.displayOrder == 9)
            // Flexタイプ
            var flexType
            if (this.targetData.mode == 1) { // Auto CPAPモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 8)
            } else if (this.targetData.mode == 4) { // CPAPモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 7)
            }
            // Flexタイプ:0、Flex設定:値がある場合
            if (flexType.value == "0" && flex.value != "") {
              correlationList.push({
                displayOrder: flexType.displayOrder,
                msg: "FlexタイプまたはFlex設定どちらかを選択してください\n",
              });
            }
            break;
          case 4:
            // ドリームステーションBiPAP Auto
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "4"){
              // CPAPモード
              var pressureCpap = this.targetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.targetData.mode == "8"){
              // Bi-Levelモード
              var epap = this.targetData.prescriptionItems.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var ipap = this.targetData.prescriptionItems.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epap.displayOrder,
                    msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(epap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「EPAP」以下の値を設定してください。\n",
                  });
                }
              }
              var flex = this.targetData.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if(flex.value=="1"){
                // 20251128_緊急対応
                // Bi-Flex
                // if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                //   if(Number(epap.value) == Number(ipap.value)){
                //     // 「IPAPの値≠EPAPの値」でない場合
                //     errMsg = errMsg + "「EPAP」「IPAP」に異なる値を設定してください。\n"
                //   }
                // }
              }else if(flex.value=="2" || flex.value=="3"){
                // C-Flex
                // C-Flex+
                if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                  if(Number(epap.value) != Number(ipap.value)){
                    // 「IPAPの値=EPAPの値」でない場合
                    correlationList.push({
                      displayOrder: epap.displayOrder,
                      msg: "「EPAP」「IPAP」に同じ値を設定してください。\n",
                    });
                  }
                }
              }
            }else if(this.targetData.mode == "1"){
              // Auto Bi-Levelモード
              var epapMin = this.targetData.prescriptionItems.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var ipapMax = this.targetData.prescriptionItems.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epapMin.value) > Number(ipapMax.value)){
                  // "EPAP最小圧【hPa(cmH2O)】" <= "IPAP最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epapMin.displayOrder,
                    msg: "「EPAP最小圧」に「IPAP最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              var psMin = this.targetData.prescriptionItems.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var psMax = this.targetData.prescriptionItems.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(psMin.value) > Number(psMax.value)){
                  // "PS最小圧【hPa(cmH2O)】" <= "PS最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: psMin.displayOrder,
                    msg: "「PS最小圧」に「PS最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                // QA267_DS BiPAP AutoにおいてminEPAPとmaxIPAPの差分とPSの設定範囲の関係性が考慮できていない
                if (Number(ipapMax.value) - Number(epapMin.value) < Number(psMax.value)) {
                  // "IPAP最大圧【hPa(cmH2O)"-"EPAP最小圧【hPa(cmH2O)】" >= "PS最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: psMax.displayOrder,
                    msg: "「PS最大圧」に「IPAP最大圧」-「EPAP最小圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(epapMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「EPAP最小圧」以下の値を設定してください。\n",
                  });
                }
              }
              // QA474_処方値関連残
              // Bipap（Auto Bi-Levelモード）IPAP＝EPAPのときPS最大圧、PS最小圧は0－0で非活性とする。
              if (errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if((Number(epapMin.value) == Number(ipapMax.value)) && (Number(psMax.value) != 0 || Number(psMin.value) != 0)){
                  correlationList.push({
                    displayOrder: psMax.displayOrder,
                    msg: "「IPAP最大圧」と「EPAP最小圧」が同じ値の場合、「PS最大圧」と「PS最小圧」に0を設定してください。\n",
                  });
                }
              }
              var flex = this.targetData.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if(flex.value=="1"){
                // 20251128_緊急対応
                // Bi-Flex
                // if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                //   if(Number(psMin.value)==0 && Number(psMax.value)==0){
                //     // 「PS最小圧≠0 または PS最大圧≠0 」でない場合
                //     errMsg = errMsg + "「PS最小圧」または「PS最大圧」に0以外の値を設定してください。\n"
                //   }
                // }
              }else if(flex.value=="2"){
                // C-Flex
                if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                  if(Number(psMin.value)!=0 || Number(psMax.value)!=0){
                    // 「PS最小圧=0」且つ「PS最大圧=0」でない場合
                    correlationList.push({
                      displayOrder: psMin.displayOrder,
                      msg: "「PS最小圧」「PS最大圧」に0を設定してください。\n",
                    });
                  }
                }
              }
            }
            // Flex設定,Flexタイプの相関チェック
            // Flex設定
            var flex = this.targetData.prescriptionItems.find(val => val.displayOrder == 13)
            // Flex設定ロック
            var flexLock = this.targetData.prescriptionItems.find(val => val.displayOrder == 14)
            // Flexタイプ
            var flexType
            if (this.targetData.mode == 1) { // Auto Bi-Levelモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 12)
            } else if (this.targetData.mode == 4) { // CPAPモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 10)
            } else if (this.targetData.mode == 8) { // Bi-Levelモード
              flexType = this.targetData.prescriptionItems.find(val => val.displayOrder == 11)
            }
            // Flexタイプ:0、Flex設定:値がある場合
            if (flexType.value == "0" && flex.value != "") {
              correlationList.push({
                displayOrder: flexType.displayOrder,
                msg: "FlexタイプまたはFlex設定どちらかを選択してください\n",
              });
            }
            if (this.targetData.mode == 1 || this.targetData.mode == 8) {
              // QA474_処方値関連残
              // Bipap（Auto Bi-Levelモード、Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
              if (flexType.value == "0" && flexLock.value != "") {
                correlationList.push({
                  displayOrder: flexType.displayOrder,
                  msg: "FlexタイプまたはFlex設定ロックどちらかを選択してください\n",
                });
              }
            }

            // ライズタイム,Flexタイプの相関チェック
            // ライズタイム
            var riseTime = this.targetData.prescriptionItems.find(val => val.displayOrder == 15)
            // Auto Bi-Levelモード
            // Flexタイプ:Bi-Flex（1）またはC-Flex（2）、ライズタイム:空の場合、ライズタイムは非活性
            // Bi-Levelモード
            // Flexタイプ:Bi-Flex（1）またはC-Flex（2）またはC-Flex+（3）、ライズタイム:空の場合、ライズタイムは非活性
            if ((flexType.value == "1"  || flexType.value == "2" || flexType.value == "3") && riseTime.value != "") {
              correlationList.push({
                displayOrder: flexType.displayOrder,
                msg: "Flexタイプまたはライズタイムどちらかを選択してください\n",
              });
            }

            // ライズタイムロック,Flexタイプの相関チェック
            // ライズタイムロック
            var riseTimeLock = this.targetData.prescriptionItems.find(val => val.displayOrder == 16)
            // Auto Bi-Levelモード
            // Flexタイプ:Bi-Flex（1）またはC-Flex（2）、ライズタイムロック:空の場合、ライズタイムロックは非活性
            // Bi-Levelモード
            // Flexタイプ:Bi-Flex（1）またはC-Flex（2）またはC-Flex+（3）、ライズタイムロック:空の場合、ライズタイムロックは非活性
            if ((flexType.value == "1"  || flexType.value == "2" || flexType.value == "3") && riseTimeLock.value != "") {
              correlationList.push({
                displayOrder: flexType.displayOrder,
                msg: "Flexタイプまたはライズタイムロックどちらかを選択してください\n",
              });
            }
            // QA513 ライズタイム「0」×川越発送×本体出荷指示チェックがある場合、バリデーション制御を追加
            // DS BipapAutoのBi-LevelモードまたはAuto Bi-Levelモード、かつFlexタイプ「オフ」のときライズタイム「0～3」が選択可能
            if (this.targetData.mode == 1 || this.targetData.mode == 8) {
              if (riseTime.value == "0" && this.targetData.senderType == "0") {
                if (this.targetData.estimateDetailCode) {
                  let targets = this.targetData.estimateDetailCode.find(val => val.itemCode == this.targetData.model)
                  if (targets && targets.shippingInstructionsFlg) {
                    correlationList.push({
                      displayOrder: riseTime.displayOrder,
                      msg: "ライズタイム「1~3」のみ川越直送可能です。\n支店出荷への変更、もしくは設定内容を確認してください。\n",
                    });
                  }
                }
              }
            }
            // QA513 EZ-Start「ON」×川越発送×本体出荷指示チェックがある場合、バリデーションを追加
            var ezStart = this.targetData.prescriptionItems.filter(val=>{ return val.displayName == 'Ez-Start'})
            if (ezStart[0].value == '1' && this.targetData.senderType == '0') {
              if (this.targetData.estimateDetailCode) {
                let targets = this.targetData.estimateDetailCode.find(val => val.itemCode == this.targetData.model)
                if (targets && targets.shippingInstructionsFlg) {
                  correlationList.push({
                    displayOrder: ezStart[0].displayOrder,
                    msg: "EZ-Start「OFF」のみ川越直送可能です。\n支店出荷への変更、もしくは設定内容を確認してください。\n",
                  });
                }
              }
            }
            // 加湿モード、回路温度設定の相関チェック
            // 加温加湿器
            var moist = this.targetData.prescriptionItems.find(val => val.displayOrder == 30)
            // 加湿モード
            var moistMode = this.targetData.prescriptionItems.find(val => val.displayOrder == 32)
            // 回路温度設定
            var circuit = this.targetData.prescriptionItems.find(val => val.displayOrder == 34)
            // 加温加湿器:1、加湿モード:0または1、回路温度設定:値がある場合
            if (moist.value == "1" && (moistMode.value == "0" || moistMode.value=="1") && circuit.value != "") {
              correlationList.push({
                displayOrder: moistMode.displayOrder,
                msg: "加湿モードまたは回路温度設定どちらかを選択してください\n",
              });
            }
            // QA474_処方値関連残
            // マスクフィットチェックオン且つ出荷元川越を選択した場合、バリデーションを追加する。
            var maskFitCheck = this.targetData.prescriptionItems.find(val => val.displayName == "マスクフィットチェック")
            if (maskFitCheck && maskFitCheck.value) {
              if (maskFitCheck.value == "1" && this.targetData.senderType == "0") {
                // QA513 出荷指示チェックの条件追加
                if (this.targetData.estimateDetailCode) {
                  let targets = this.targetData.estimateDetailCode.find(val => val.itemCode == this.targetData.model)
                  if (targets && targets.shippingInstructionsFlg) {
                    correlationList.push({
                      displayOrder: maskFitCheck.displayOrder,
                      msg: "マスクフィットチェック「OFF」のみ川越直送可能です。\n支店出荷への変更、もしくは設定内容を確認してください。\n",
                    });
                  }
                }
              }
            }
            break;
          case 5:
            // エスボックス バイスタルク
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
            if(this.targetData.mode == "4"){
              // CPAPモード
              // "ランプ開始圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
            }else if(this.targetData.mode == "1"){
              // Auto CPAPモード
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("ランプ開始圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプ開始圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプ開始圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            //川越出荷の場合かつ本体の処方変更がない場合
            var otherProducts = []
            otherProducts = this.targetData.estimateDetailCode.filter(val => {return val.itemCode == "R1152708" || val.itemCode == "R1151127"})
            if(otherProducts){
              var shippingInstructionsFlg = otherProducts.find(val => {return val.shippingInstructionsFlg == true})
            }
            if(this.targetData.senderType=='0' && shippingInstructionsFlg){
              errorMsg = errorMsg + "※エスボックスバイスタルクの場合、発送元は支店を選択してください。\n"
            }

            // CC+、CC+機能有効時間 全治療時間、CC+機能有効時間 ランプのみの相関チェック
            // CC+
            var cc = this.targetData.prescriptionItems.find(val => val.displayOrder == 6)
            // CC+機能有効時間 全治療時間
            var ccAll = this.targetData.prescriptionItems.find(val => val.displayOrder == 7)
            // CC+機能有効時間 ランプのみ
            var ccLamp = this.targetData.prescriptionItems.find(val => val.displayOrder == 8)
            // CC+：OFF（0）、CC+機能有効時間 全治療時間：値あり
            if (cc.value == "0" && ccAll.value != "") {
              correlationList.push({
                displayOrder: cc.displayOrder,
                msg: "CC+またはCC+機能有効時間 全治療時間どちらかを選択してください\n",
              });
            }
            // CC+：OFF（0）、CC+機能有効時間 ランプのみ：値あり
            if (cc.value == "0" && ccLamp.value != "") {
              correlationList.push({
                displayOrder: cc.displayOrder,
                msg: "CC+またはCC+機能有効時間 ランプのみどちらかを選択してください\n",
              });
            }
            // CC+：ON（1）、CC+機能有効時間ランプのみ：値あり、CC+機能有効時間 全治療時間：値あり
            if (cc.value == "1" && ccLamp.value != "" && ccAll.value != "") {
              correlationList.push({
                displayOrder: cc.displayOrder,
                msg: "CC+機能有効時間 全治療時間またはCC+機能有効時間 ランプのみどちらかを選択してください\n",
              });
            }

            // ランプ機能、ランプタイムの相関チェック
            // ランプ機能
            var lamp = this.targetData.prescriptionItems.find(val => val.displayOrder == 9)
            // ランプタイム
            var lampTime = this.targetData.prescriptionItems.find(val => val.displayOrder == 10)
            // ランプ機能：０（オフ）、ランプタイム：値あり
            if (lamp.value == "0" && lampTime.value != "") {
              correlationList.push({
                displayOrder: lamp.displayOrder,
                msg: "ランプ機能またはランプタイムどちらかを選択してください\n",
              });
            }
            // ランプ機能、ランプ時間【分】の相関チェック
            // ランプ時間【分】
            var lampTimeMinutes = this.targetData.prescriptionItems.find(val => val.displayOrder == 11)
            // ランプ機能：０（オフ）、ランプ時間【分】：値あり
            if (lamp.value == "0" && lampTimeMinutes.value != "") {
              correlationList.push({
                displayOrder: lamp.displayOrder,
                msg: "ランプ機能またはランプ時間【分】どちらかを選択してください\n",
              });
            }
            // ランプ機能、ランプタイム、ランプ時間【分】の相関チェック
            // ランプ機能：1（オン）、ランプタイム：I.RAMP（1）、ランプ時間【分】：値あり
            if (lamp.value == "1" && lampTime.value == "1" && lampTimeMinutes.value != "") {
              correlationList.push({
                displayOrder: lamp.displayOrder,
                msg: "ランプタイムまたはランプ時間【分】どちらかを選択してください\n",
              });
            }
            // ランプ機能、ランプ開始圧【hPa(cmH2O)】の相関チェック
            // ランプ開始圧【hPa(cmH2O)】
            var lampStart = this.targetData.prescriptionItems.find(val => val.displayOrder == 12)
            // ランプ機能：０（オフ）、ランプ開始圧【hPa(cmH2O)】：値あり
            if (lamp.value == "0" && lampStart.value != "") {
              correlationList.push({
                displayOrder: lamp.displayOrder,
                msg: "ランプ機能またはランプ開始圧【hPa(cmH2O)】どちらかを選択してください\n",
              });
            }

            break;
          case 6:
            // プリズマ ライン (prisma25S)
            if(this.targetData.mode == "1"){
              // APAPモード
              var pressureMax = this.targetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pressureMin = this.targetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.targetData.mode == "7"){
              // Sモード
              var epap = this.targetData.prescriptionItems.find(val => val.displayName == "EPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var ipap = this.targetData.prescriptionItems.find(val => val.displayName == "IPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP圧【hPa（cmH2O)】") == -1 && errorMsg.indexOf("IPAP圧【hPa（cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP圧【hPa（cmH2O)】" <= "IPAP圧【hPa（cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epap.displayOrder,
                    msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.targetData.mode == "9"){
              // autoSモード
              var pdiffMin = this.targetData.prescriptionItems.find(val => val.displayName == "PDIFF min 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              var pdiffMax = this.targetData.prescriptionItems.find(val => val.displayName == "PDIFF max 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.targetData.mode)) != -1))
              if (errorMsg.indexOf("PDIFF min 圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PDIFF max 圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pdiffMin.value) > Number(pdiffMax.value)){
                  // "PDIFF min 圧【hPa(cmH2O)】" <= "PDIFF max 圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: pdiffMin.displayOrder,
                    msg: "「PDIFF min 圧」に「PDIFF max 圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            //川越出荷の場合かつ本体の処方変更がない場合
            var otherProducts = []
            otherProducts = this.targetData.estimateDetailCode.filter(val => {return val.itemCode == "R1151882"})
            if(otherProducts){
              var shippingInstructionsFlg = otherProducts.find(val => {return val.shippingInstructionsFlg == true})
            }
            if(this.targetData.senderType=='0' && shippingInstructionsFlg){
              errorMsg = errorMsg + "※プリズマライン(prisma25S)の場合、発送元は支店を選択してください。\n"
            }
            break;
        }
      }

      /** 加湿器、通信モジュール */
      const validateResult = await child.$validator.validateAll()
      // QA427_エラー内容を項目ごとに取得
      const errorList = child.$validator.errors.items;

      // 必須チェック結果をdisplayOrderとメッセージのみにする
      const sortList = errorList.map(val => {
        const match = val.field.match(/_(\d+)$/);
        let num = match ? Number(match[1]) : null;
        if (val.field.includes("form2")) {          // 本体
          num = num + 1;
        } else if (val.field.includes("form3_2")) { // モデム
          num = num + 200;
        } else if (val.field.includes("form3")) {   // 加湿器
          num = num + 100;
        }
        return {
          displayOrder: num,
          msg: val.msg + "。\n",
        };
      });

      var moistInfo = document.getElementsByClassName("moistInfo");
      var moistInfoResult = this.selfMadeValidation(moistInfo);
      if (moistInfoResult.isError) {
        sortList.push({
          displayOrder: 150,
          msg: moistInfoResult.msg,
        });
      }
      var moduleInfo = document.getElementsByClassName("moduleInfo");
      var moduleInfoResult = this.selfMadeValidation(moduleInfo);
      if (moduleInfoResult.isError) {
        sortList.push({
          displayOrder: 250,
          msg: moduleInfoResult.msg,
        });
      }

      // 必須チェックと相関チェックのエラーメッセージを統合してdisplayOrder順に並び替え
      sortList.push(...correlationList);
      sortList.sort((first, second) => first.displayOrder - second.displayOrder);

      // 表示するメッセージ変数に格納
      for (var i = 0; i < sortList.length; i++) {
        const error = sortList[i];
        errorMsg = errorMsg + error.msg;
      }

      /** マスク */
      if(!this.targetData.maskItemCode){
        errorMsg = errorMsg + "「マスク」は必須項目です。\n"
      }else{
        //マスク枠内各項目必須チェック
        if(!this.targetData.maskType){// マスク：種類
          errorMsg = errorMsg + "「マスク：種類」は必須項目です。\n"
        }
        if(!this.targetData.cushionSize){// マスク：クッションサイズ
          errorMsg = errorMsg + "「マスク：クッションサイズ」は必須項目です。\n"
        }
        if(!this.targetData.frameSize){// マスク：フレームサイズ
          errorMsg = errorMsg + "「マスク：フレームサイズ」は必須項目です。\n"
        }
        if(!this.targetData.fixingMethod){// マスク：固定方法
          errorMsg = errorMsg + "「マスク：固定方法」は必須項目です。\n"
        }
      }

      /** 納品先情報 */
      var deliveryInfo = document.getElementsByClassName("deliveryInfo");
      var deliveryInfoResult = this.selfMadeValidation(deliveryInfo);
      errorMsg = errorMsg + deliveryInfoResult.msg;
      // QA513 DS Go×川越発送×本体出荷指示チェックがある場合、バリデーションを追加
      if (this.targetData.model == 'RJPG500S16' && this.targetData.senderType == '0') {
        if (this.targetData.estimateDetailCode) {
          let targets = this.targetData.estimateDetailCode.find(val => val.itemCode == this.targetData.model)
          if (targets && targets.shippingInstructionsFlg) {
            errorMsg = errorMsg + "DS Goは川越直送にて対応できません。\n支店出荷への変更してください。\n"
          }
        }
      }

      /** 返却情報 */
      // 機器返却がある場合は返却先は必須
      if(this.targetData.machineReturn){
        var collectionDestination1 = document.getElementById("collectionDestination1");
        var collectionDestination2 = document.getElementById("collectionDestination2");
        collectionDestination1.style["color"] = "";
        collectionDestination2.style["color"] = "";
        if(!(this.targetData.collectionDestination+"") || this.targetData.collectionDestination == null){
          // 機器返却がある処方変更で、返却先未設定
          errorMsg = errorMsg + "「返却先」は必須項目です。\n"
          collectionDestination1.style["color"] = "red";
          collectionDestination2.style["color"] = "red";
        }
      }

      var returnInfo = document.getElementsByClassName("returnInfo");
      var returnInfoResult = this.selfMadeValidation(returnInfo);
      errorMsg = errorMsg + returnInfoResult.msg;

      /** オーダー情報 */
      var orderInfo = document.getElementsByClassName("orderInfo");
      var orderInfoResult = this.selfMadeValidation(orderInfo);
      errorMsg = errorMsg + orderInfoResult.msg;

      // QA427_エラーメッセージを一気に表示
      if (!validateResult || errorMsg ) {
        this.showErrorMessage(errorMsg)
        return
      }
      //20230428追加
      let orderMsg = "";
      let itemList;
      // 新規処方、仮持出新規、再開、処方変更申込みの場合
      if(this.targetKind == 1 || this.targetKind == 2  || this.targetKind == 5 || this.targetKind == 7){
        //出荷指示がある品目のみ抽出
        itemList = this.targetData.estimateDetailCode.filter(val => {return val.shippingInstructionsFlg == true})
      }else{
        itemList = this.targetData.estimateDetailCode;
      }
      for (var i = 0; i < itemList.length; i++) {
        orderMsg = orderMsg + "&#12288;● " + itemList[i].itemName + "<br/>";
      }

      // QA80 確定時モーダルのメッセージを修正
      const title = "オーダー内容の確認";
      let msg = "";
      let typeMsg = "";
      let consistencyCheckErr = child.cpapConsistencyCheckErr();
      let isShipping = false;
      let billingStartDate = this.targetData.billingStartDate ? this.targetData.billingStartDate.replace(/-/g, "/") : "";

      // 種別を判定しモーダルの注釈文を決定
      if (this.targetData.notDirections || this.resume) {
        // 仮持出、転院通常再開の場合
        typeMsg = "※仮持出からレンタルとして連携されます。";
      } else if (this.targetData.depositUseFlag) {
        // 預託の場合
        typeMsg = "※預託からの契約変更として連携されます。";

        // 見積情報チェック
        if (consistencyCheckErr) {
          this.showErrorMessage("<strong>" + typeMsg + "</strong>")//QA68_20231228
          return
        }
      } else {
        // 通常の場合
        typeMsg = "※支店または川越のピッキング対象として連携されます。";
      }

      // 出荷指示が入っているかチェック
      for (i = 0; i < child.directionsItemList.length; i++) {
        if (child.directionsItemList[i].shippingInstructionsFlg) {
          isShipping = true;
          break;
        }
      }

      // 出荷指示が入っているかどうかで表示するメッセージを分ける
      if (isShipping) {
        msg = msg
          + "■以下の内容がDollyに連携されます。<br/>"
          + orderMsg
          + "<strong/>" + typeMsg + "</strong><br/><br/>"
          + "&#12288;● 請求開始日&#12288;" + billingStartDate +"<br/><br/>";
      } else {
        msg = msg + "出荷する品目はありません。<br/>";
      }
      msg = msg + "内容をご確認のうえ「OK」ボタンを押してください。";

      if(this.targetData.maskItemCode == '-'){
        //マスクの種類がその他の場合
        msg = msg + "<br>必要に応じて別途マスクの対応を行ってください。"
      }
      this.$dialog.confirm({
        title: title,
        message: msg,
        cancelText: "修正する",
        onConfirm: async () => {
          var excuteApi = this.setCpapRequestConfirmPOST;
          var successCallBack = this.setCpapRequestConfirmPOSTSuccess;
          var errorCallBack = this.setCpapRequestConfirmPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      });
    },
    cancelConfirm: async function() {
      // 申請確定(処方中止)
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      var excuteApi = this.setCpapRequestConfirmPOST;
      var successCallBack = this.setCpapRequestConfirmPOSTSuccess;
      var errorCallBack = this.setCpapRequestConfirmPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    transFerConfirm: async function() {
      // 申請確定(転院)
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      var excuteApi = this.setCpapRequestConfirmPOST;
      var successCallBack = this.setCpapRequestConfirmPOSTSuccess;
      var errorCallBack = this.setCpapRequestConfirmPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    setCpapRequestConfirmPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.targetData));
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      // QA478　選択していないモードの設定値をデフォルトに変更する
      if (obj.prescriptionItems && obj.mode) {
        for (let setting of obj.prescriptionItems) {
          switch(setting.category) {
            case 0: // 本体
              if (setting.mode && !setting.mode.includes("0") && !setting.mode.includes(obj.mode)) {
                setting.value = setting.defaultValue
              }
              break;
            case 1: // 加湿器
            case 2: // モデム
              break;
          }
        }
      }
      // 無の場合は、品目コード、シリアルを初期化
      obj.moistItemCode = !obj.useMoist ? "" : obj.moistItemCode
      obj.moistSerial = !obj.useMoist ? "" : obj.moistSerial
      obj.moduleItemCode = !obj.useModule ? "" : obj.moduleItemCode
      obj.moduleSerial = !obj.useModule ? "" : obj.moduleSerial
      // 各パラメータの型変換
      obj.expectedReturnDate = obj.expectedReturnDate ? obj.expectedReturnDate.replace(/-/g, "/") : ""
      obj.transferDate = obj.transferDate ? obj.transferDate.replace(/-/g, "/") :""
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") : ""
      obj.billingStartDate = obj.billingStartDate ? obj.billingStartDate.replace(/-/g, "/") : ""
      // obj.shippingDate = obj.senderType==1 && obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.appointedDeliveryDate = obj.appointedDeliveryDate ? obj.appointedDeliveryDate.replace(/-/g, "/") : ""
      obj.specifiedDeliveryDate = obj.specifiedDeliveryDate ? obj.specifiedDeliveryDate.replace(/-/g, "/") : ""

      // 改行コード、タブを除去
      Object.keys(obj).forEach(key => {
        if (obj[key]) {
          obj[key] = this.replaceCharTab(obj[key]);
        }
      })
      Object.keys(obj.patient).forEach(key => {
        if (obj.patient[key]) {
          obj.patient[key] = this.replaceCharTab(obj.patient[key]);
        }
      })

      for(var i=0; i < obj.prescriptionItems.length; i++){
        let item = obj.prescriptionItems[i]
        if(item.category==1){
          if(!obj.useMoist){
            // 加湿器「無」の場合、関連項目の処方値をクリアする
            if(item.type!="radio"){
              item.value = ""
            }
          }
          continue
        }
        if(obj.reportFormatType!=3 && item.category==2){
          if(!obj.useModule){
            // 通信モジュール「無」の場合、関連項目の処方値をクリアする
            if(item.type!="radio"){
              item.value = ""
            }
          }
          continue
        }
        if(obj.reportFormatType==6 && item.category==2){
          item.value = ""
        }
      }
      if(!obj.useMoist){
        obj.moistItemCode = ""
        obj.moistSerial = ""
      }
      if(!obj.useModule){
        obj.moduleItemCode = ""
        obj.moduleSerial = ""
      }
      return client.apis.internalCpap.setCpapRequestConfirmPOST({
        body:obj
      });
    },
    setCpapRequestConfirmPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestConfirmPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    transferCancel: async function() {
      // QA418 転院から中止申込みに変更
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      var excuteApi = this.setCpapRequestTransferCancelPOST;
      var successCallBack = this.setCpapRequestTransferCancelPOSTSuccess;
      var errorCallBack = this.setCpapRequestTransferCancelPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    setCpapRequestTransferCancelPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.targetData));
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      // QA478　選択していないモードの設定値をデフォルトに変更する
      if (obj.prescriptionItems && obj.mode) {
        for (let setting of obj.prescriptionItems) {
          switch(setting.category) {
            case 0: // 本体
              if (setting.mode && !setting.mode.includes("0") && !setting.mode.includes(obj.mode)) {
                setting.value = setting.defaultValue
              }
              break;
            case 1: // 加湿器
            case 2: // モデム
              break;
          }
        }
      }
      // 無の場合は、品目コード、シリアルを初期化
      obj.moistItemCode = !obj.useMoist ? "" : obj.moistItemCode
      obj.moistSerial = !obj.useMoist ? "" : obj.moistSerial
      obj.moduleItemCode = !obj.useModule ? "" : obj.moduleItemCode
      obj.moduleSerial = !obj.useModule ? "" : obj.moduleSerial
      // 各パラメータの型変換
      obj.expectedReturnDate = obj.expectedReturnDate ? obj.expectedReturnDate.replace(/-/g, "/") : ""
      obj.transferDate = obj.transferDate ? obj.transferDate.replace(/-/g, "/") :""
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") : ""
      obj.billingStartDate = obj.billingStartDate ? obj.billingStartDate.replace(/-/g, "/") : ""
      // obj.shippingDate = obj.senderType==1 && obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.appointedDeliveryDate = obj.appointedDeliveryDate ? obj.appointedDeliveryDate.replace(/-/g, "/") : ""
      obj.specifiedDeliveryDate = obj.specifiedDeliveryDate ? obj.specifiedDeliveryDate.replace(/-/g, "/") : ""

      // 改行コード、タブを除去
      Object.keys(obj).forEach(key => {
        if (obj[key]) {
          obj[key] = this.replaceCharTab(obj[key]);
        }
      })
      Object.keys(obj.patient).forEach(key => {
        if (obj.patient[key]) {
          obj.patient[key] = this.replaceCharTab(obj.patient[key]);
        }
      })

      for(var i=0; i < obj.prescriptionItems.length; i++){
        let item = obj.prescriptionItems[i]
        if(item.category==1){
          if(!obj.useMoist){
            // 加湿器「無」の場合、関連項目の処方値をクリアする
            if(item.type!="radio"){
              item.value = ""
            }
          }
          continue
        }
        if(obj.reportFormatType!=3 && item.category==2){
          if(!obj.useModule){
            // 通信モジュール「無」の場合、関連項目の処方値をクリアする
            if(item.type!="radio"){
              item.value = ""
            }
          }
          continue
        }
        if(obj.reportFormatType==6 && item.category==2){
          item.value = ""
        }
      }
      if(!obj.useMoist){
        obj.moistItemCode = ""
        obj.moistSerial = ""
      }
      if(!obj.useModule){
        obj.moduleItemCode = ""
        obj.moduleSerial = ""
      }
      obj.isTransferCancel = this.isTransferCancel
      return client.apis.internalCpap.setCpapRequestTransferCancelPOST({
        body:obj
      });
    },
    setCpapRequestTransferCancelPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestTransferCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    doSearch: function() {
    var excuteApi = this.getCpapMatterDetailsPOST;
    var successCallBack = this.getCpapMatterDetailsPOSTSuccess;
    var errorCallBack = this.getCpapMatterDetailsPOSTError;
    // Web Api Call
    this.apiCall(excuteApi, successCallBack, errorCallBack);
  },
  getCpapMatterDetailsPOST: function(client) {
      return client.apis.internalCpap.getCpapMatterDetailsPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getCpapMatterDetailsPOSTSuccess: function(result) {
      // 検索結果取得
      this.targetData = result.obj
      this.compareTarget = result.obj.compareTarget
      this.targetData.onlyCollectionFlag = false;
      this.initialUseModule = result.obj.useModule; // 初期表示状態を記録　QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白
      this.initialUseMoist = result.obj.useMoist; // 初期表示状態を記録　QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白
      this.mode = "show";
      this.kind = "Req";
      var progress = this.getCpapProgres(this.targetData.status)
      if(progress.indexOf("仮受付") != -1) {
        this.mode = "edit";
      }
      var type = this.getCpapKind(this.targetData.kind)
      if(type.indexOf("預託機申込み") != -1){
        this.kind = "Ins"
      }else if(type.indexOf("仮持出申込み") != -1){
        this.kind = "Temp"
      }else if(type.indexOf("転院申込み") != -1){
        this.kind = "Transfer"
      }else if(type.indexOf("処方中止申込み") != -1){
        this.kind = "Cancel"
        if(progress.indexOf("仮受付") != -1) {
          // 処方中止の仮受付時のみ前回オーダーIDを取得
          this.getOldOrder();
        }
      }else if(type.indexOf("処方再開(転院患者)申込み") != -1 && !this.targetData.cancelResume){
        this.resume = true
      }
      if (this.isTransferCancel) {
        // QA418 転院から処方中止申込み
        this.targetData.kind = cpapKindMap.applicationCancel
        this.targetData.status = this.status
        this.mode = "edit"
        this.kind = "Cancel"
      }

      this.type = this.mode + this.kind
      console.log(this.type)
      this.renderKey = !this.renderKey
    },
    getCpapMatterDetailsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result.message,this.back());
    },
    cancel: function(cancelReason) {
      // キャンセル
      this.reason = cancelReason
      var excuteApi = this.setCpapRequestCancelPOST;
      var successCallBack = this.setCpapRequestCancelPOSTSuccess;
      var errorCallBack = this.setCpapRequestCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapRequestCancelPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.targetData));
      obj.reason = this.reason
      return client.apis.internalCpap.setCpapRequestCancelPOST({
        body:obj
      });
    },
    setCpapRequestCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    sendBack: function(sendBackReason) {
      this.reason = sendBackReason
      const excuteApi = this.setCpapSendBackPOST;
      const successCallBack = this.setCpapSendBackPOSTSuccess;
      const errorCallBack = this.setCpapSendBackPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    setCpapSendBackPOST: function(client) {
      return client.apis.internalCpap.setCpapSendBackPOST({
        body:{
          receiptNumber:this.targetData.receiptNumber,
          reason:this.reason,
          orderId:this.targetData.orderId,
          UserCd:this.userInfo.lastName + " " + this.userInfo.firstName,
          roleId:this.userInfo.roleId,
          userInfo:this.userInfo,
        }
      });
    },
    setCpapSendBackPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back();
    },
    setCpapSendBackPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getOldOrder: async function() {
      // 前回処方時のオーダー情報取得
      let oldOrderId = ""
      if(this.targetData.oldOrderId){
        oldOrderId = this.targetData.oldOrderId
      }
      if(oldOrderId == ""){
        this.orderFlg = true
        return this.showMessage('オーダー情報が前の案件に紐づいていないため処理できません。<br>保守担当者へ紐づけを依頼してください。');
      }
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getCpapOrderPOST({
            body:{
              orderId: oldOrderId ? oldOrderId : "",
              cancelFlag: true
            }
          });
        },
        async function(result){
          // 請求先コード、得意先コード取得
          if(result.obj && result.obj.length >0){
            _this.targetData.orderBillingDestinationCode = result.obj[0].billingDestinationCode
            _this.targetData.orderHospitalCode = result.obj[0].hospitalCode
          }else{
            _this.orderFlg = true;
            _this.showMessage('前の案件に紐づいているオーダー情報に誤りがある可能性があり処理できません。<br>保守担当者へ確認を依頼してください。');
          }
        },
        function(result){
          _this.orderFlg = true;
          _this.showErrorMessage(result);
        }
      );
    },
    replaceCharTab: function(inputChar) {
      if (typeof inputChar == 'string') {
        inputChar = inputChar.replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '');
      }
      return inputChar;
    },
    downloadInstructionsPDF: function(){
      var _this = this;
      this.downloadApiCall(function(client){
          return client.apis.apiCommon.getInstructionsPDFPOST({
            body:{receiptNumber:_this.targetNumber}
          })
        },
        function(message) {
          _this.showErrorMessage(message);
        }
      );
    }
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var targetKind = this.$route.params["kind"];
    var targetStatus = this.$route.params["status"];
    var searchParams = this.$route.params["searchConditions"];
    var temp = this.$route.params["isTemp"];
    var targetId = this.$route.params["targetId"];
    var isTransferCancel = this.$route.params["isTransferCancel"];
    var kindGroupMaster = this.getCpapKindList();
    var progressList = this.getCpapProgressList();
    var mode = "show";
    var kind = "Req";
    var progress = this.getCpapProgres(targetStatus)
    var tempFlg = false
    var oldEstimateItemCodes ="";
    var orderFlg = false
    var initialUseModule = true; // QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白
    var initialUseMoist = true; // QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白
    var compareTarget = "";
    if(progress.indexOf("仮受付") != -1) {
      mode = "edit";
    }
    var type = this.getCpapKind(targetKind)
    if(type.indexOf("預託機申込み") != -1){
      kind = "Ins"
    }else if(type.indexOf("仮持出申込み") != -1 || temp){
      kind = "Temp"
      tempFlg = true
    }
    // 新規処方、処方変更、処方中止、転院、処方再開、仮持出(登録済み)、機器返却(預託機)
    //   ⇒　CpapRequestDetail
    // 仮持出申込(申込み中)
    //   ⇒　cpapRequestDetailEdit
    // 預託機申込
    //   ⇒　cpapInstrumentRequestDetail

    // 下記申請中の申込の確定が可能
    // 新規処方、処方変更、処方中止、転院、処方再開、預託機申込、機器返却(預託機)

    // 全申込キャンセルが可能
    var cpapAccessories = this.getCpapAccessoryList();
    var modelList = this.getCpapMaster();

    // 管理者、川越CPAPのみ差し戻し可能
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const roleId = userInfo.roleId;
    return {
      targetNumber,
      searchParams,
      progressList,
      kindGroupMaster,
      targetData: {},
      type: mode + kind,
      mode:mode,
      kind: targetKind,
      status:targetStatus,
      cancelReasonInputModalActive:false,
      sendBackReasonInputModalActive:false,
      reason:"",
      cpapRequestStatus,
      cpapAccessories,
      modelList,
      tempFlg,
      renderKey:false,
      resume:false,
      targetKind:targetKind,
      oldEstimateItemCodes:oldEstimateItemCodes,
      orderFlg,
      userInfo,
      roleId,
      role,
      cpapKindMap,
      cpapSenderMaster,
      inactive:false,
      childOnlyCollectionFlag:false,
      initialUseModule, // QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白
      initialUseMoist, // QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白
      compareTarget,
      targetId: targetId,
      isTransferCancel: isTransferCancel
    };
  },
  filters: {
    statusFilter: function(value){
    }
  },
  components: {
    cpapRequestDetail:CpapRequestDetail,
    cpapRequestDetailEdit:CpapRequestDetailEdit,
    cpapInstrumentRequestDetail:CpapInstrumentRequestDetail,
    cpapInstrumentRequestDetailEdit:CpapInstrumentRequestDetailEdit,
    reasonInputModal:reasonInputModal,
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.tag {
  width: 150px !important;
  height: 36px !important;
}
#requestDetailTable th {
  vertical-align: top;
}
#requestDetailTable td {
  word-break: break-all ;
}
table.flowTable,
table.dateTable {
  border-collapse: collapse;
  table-layout: fixed;
}

table.flowTable tr,
table.flowTable td,
table.dateTable th,
table.dateTable tr,
table.dateTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 100px;
  text-align: center;
}
table.dateTable td {
  padding-left: 10px;
}
table.dateTable th {
  text-align: center;
}

.diagonalline {
  background-image: linear-gradient(
    to top right,
    transparent 0%,
    transparent 49.5%,
    #5f5f5f 49.5%,
    #5f5f5f 50.5%,
    transparent 50.5%,
    transparent 100%
  );
}
.caution,
.delay {
  color: red;
  margin-right:10px;
}
.delay {
  color: red;
  font-weight: bold;
}
.height30 {
  height:30px !important;
}
.reportFiles {
  float: left;
  margin-right:10px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.h-center {
  padding-left: 0 !important;
  text-align: center; 
  margin-left: auto;
  margin-right: auto;
}
.download::after {
  position: static;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/cpap/RequestDetail.vue